export const extractPrice = (
  isWeekend: boolean,
  price,
  roomSize: number,
  tabIndex: number,
) =>
  tabIndex === 1
    ? String(price.daily_price)
    : isWeekend && price.weekend[roomSize]
    ? price.weekend[roomSize]
    : price.standard[roomSize]
